import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription, Subject, catchError, EMPTY, of, Observable } from 'rxjs';
import { map, concatMap, switchMap, tap, filter, finalize, timeout, retry } from 'rxjs/operators';

import { Table } from 'primeng/table';
import { FilterService } from 'primeng/api';
import { saveAs } from 'file-saver';

import { environment } from 'src/environments/environment';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { ProductApiService, ProductTransaction } from 'src/app/services/product-api.service';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { ClientApiService } from 'src/app/services/client-api.service';
import { DocTypes } from 'src/app/shared/doc-list-entry';

@Component({
  selector: 'app-list-products-customers-transactions',
  templateUrl: './list-products-customers-transactions.component.html',
  styleUrl: './list-products-customers-transactions.component.css',
  encapsulation: ViewEncapsulation.None
})
export class ListProductsCustomersTransactionsComponent implements OnInit, OnDestroy, OnChanges {
  private globalSettinsData: GlobalSettingsData;

  saveStateKey: string = 'list-invoiced-products-of-customer';

  @Input() clientId: number = 0;

  rows: number = 20;
  totalRecords: number = 0;

  contentLoading: boolean = false;

  productInfo: ProductTransaction[] = [];
  selectedRow: ProductTransaction = null;
  selectedProductInfo: ProductTransaction = null;

  //@ViewChild('inTransitTable') inTransitTable: Table;

  private _productQuery: Subscription;
  private _prodRowQuery: Subscription;

  private listOptions$ = new Subject<{ clientId: number, fromDate: Date, toDate: Date, docTypes: number[] }>();

  selectAllTypes: boolean = false;
  selectedDocTypes: DocTypes[];
  docTypes: DocTypes[];

  allowedDocTypes: number[] = [1, 2, 3, 4, 12];
  initialDocTypes: number[] = [1];

  filterDate: Date[] = [];
  fromDate: Date = null;
  toDate: Date = null;

  showSellerColumn: boolean = false;
  showCustomerColumn: boolean = false;
  showProductExtentionColumn: boolean = false;

  // Centralized error handler
  private handleError<T>(operation: string, result?: T) {
    return (error: any): Observable<T> => {
      //this.errorCount++;

      console.error(`${operation} failed:`, error);

      this.contentLoading = false;

      // Log to monitoring service (if available)
      // this.errorLoggingService.logError(error);

      // Show user-friendly message
      this.messageService.add({
        severity: 'error',
        summary: 'Помилка операції',
        detail: this.getUserFriendlyError(operation, error),
        life: 5000
      });

      // Return safe fallback
      return result ? of(result) : EMPTY;
    };
  }

  /**
   * Centralized error handler for component operations
   * 
   * @template T - The type of the fallback result
   * @param operation - The name of the operation that failed (used for error mapping)
   * @param result - Optional fallback value to return on error
   * @returns An observable error handler function that:
   *          - Logs the error to console
   *          - Displays a user-friendly error message via MessageService
   *          - Returns either the provided fallback value or EMPTY observable
   * 
   * @example
   * this.apiService.getData()
   *   .pipe(
   *     catchError(this.handleError('loadData', []))
   *   )
   */
  private getUserFriendlyError(operation: string, error: any): string {
    const errorMap: { [key: string]: string } = {
      'calculateDocItemsFields': 'Не вдалося завантажити дані документа',
      'saveDocItem': 'Не вдалося зберегти позицію',
      'deleteDocItem': 'Не вдалося видалити позицію',
      'loadProduct': 'Не вдалося завантажити дані товару',
      'calculateProfit': 'Помилка розрахунку прибутку',
      'exportData': 'Помилка експорту даних'
    };

    const message = errorMap[operation] || 'Невідома помилка';

    if (error.status === 0) {
      return `${message}: Немає з'єднання з сервером`;
    }
    if (error.status === 401) {
      return `${message}: Немає авторизації`;
    }
    if (error.status === 403) {
      return `${message}: Немає прав доступу`;
    }
    if (error.status === 404) {
      return `${message}: Дані не знайдено`;
    }
    if (error.status >= 500) {
      return `${message}: Помилка сервера`;
    }
    return message;
  }

  getShippedStatusClass(item: ProductTransaction): string {
    if (item.SHIPPED === 0) {
      return 'quantity-pending';
    } else if (item.SHIPPED < item.ORDERED) {
      return 'quantity-partial';
    } else {
      return 'quantity-shipped';
    }
  }

  getTotalPrice(): number {
    return this.productInfo.reduce((sum, item) =>
      sum + (item.DOCITEMPRICE * item.ORDERED), 0);
  }

  getTotalVPrice(): number {
    return this.productInfo.reduce((sum, item) =>
      sum + (item.DOCITEMVPRICE * item.ORDERED), 0);
  }

  getTotalOrdered(): number {
    return this.productInfo.reduce((sum, item) =>
      sum + item.ORDERED, 0);
  }

  getTotalShipped(): number {
    return this.productInfo.reduce((sum, item) =>
      sum + item.SHIPPED, 0);
  }

  viewDetails(item: ProductTransaction) {
    console.log('View details:', item);
    // Implement view details logic
  }

  editItem(item: ProductTransaction) {
    console.log('Edit item:', item);
    // Implement edit logic
  }

  @ViewChild('dt') table: Table;

  constructor(
    private prodApi: ProductApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private messageService: MessageService,
    private filterService: FilterService,
    private cliApi: ClientApiService,
    private docApi: DocumentApiService
  ) {

    let todate = new Date();
    this.toDate = new Date(todate.getFullYear(), todate.getMonth(), todate.getDate(), 23, 59, 59); // End of current day
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** ListProductsCustomersTransactionsComponent ngOnChanges: enter');
    //environment.production || console.table(changes);
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** ListProductsCustomersTransactionsComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      if (!change.firstChange) {
        switch (propName) {

          case 'clientId':
            this.listOptions$.next({
              clientId: this.clientId,
              fromDate: this.fromDate,
              toDate: this.toDate,
              docTypes: this.selectedDocTypes?.length ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : this.initialDocTypes
            });
            break;
        }
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** ListProductsCustomersTransactionsComponent in ngOnDestroy')

    if (this.saveStateKey != '') {
      localStorage.setItem(this.saveStateKey + '-fromDate', JSON.stringify(this.fromDate));
      localStorage.setItem(this.saveStateKey + '-toDate', JSON.stringify(this.toDate));
      //localStorage.setItem(this.saveStateKey + '-docTypes', JSON.stringify(this.selectedDocTypes));
      localStorage.setItem(this.saveStateKey + '-showProduct', JSON.stringify(this.showProductExtentionColumn));
      localStorage.setItem(this.saveStateKey + '-showCustomer', JSON.stringify(this.showCustomerColumn));
      localStorage.setItem(this.saveStateKey + '-showSeller', JSON.stringify(this.showSellerColumn));
    }

    if (this._productQuery) { this._productQuery.unsubscribe(); }

    if (this._prodRowQuery) { this._prodRowQuery.unsubscribe(); }
  }

  private buildQueryOptions(options: any): any[] {
    const queryOptions: any[] = [
      { mode: 'DOCTYPE', value: this.selectedDocTypes?.length ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : this.initialDocTypes },
      {
        mode: 'DOCFIELD',
        fieldName: 'DOCMANCLIID',
        valueType: 'number',
        operMode: 'equal',
        fieldValue: this.globalSettinsData.mainCompanyId.toString()
      },
      {
        mode: 'DOCFIELD',
        fieldName: 'DOCCLIENTSID',
        valueType: 'number',
        operMode: 'equal',
        fieldValue: options.clientId.toString()
      }
    ];

    if (options.fromDate) {
      queryOptions.push({
        mode: 'DOCFIELD',
        fieldName: 'DOCDATE',
        valueType: 'date',
        operMode: 'after',
        fieldValue: options.fromDate.toISOString()
      });
    }

    if (options.toDate) {
      queryOptions.push({
        mode: 'DOCFIELD',
        fieldName: 'DOCDATE',
        valueType: 'date',
        operMode: 'before',
        fieldValue: options.toDate.toISOString()
      });
    }

    return queryOptions;
  }

  ngOnInit(): void {
    console.log('*** ListProductsCustomersTransactionsComponent in ngOnInit')

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    if (this.saveStateKey != '') {
      try {
        const fromDateStr = localStorage.getItem(this.saveStateKey + '-fromDate');
        if (fromDateStr) {
          this.fromDate = new Date(JSON.parse(fromDateStr));
        }
        const showProductStr = localStorage.getItem(this.saveStateKey + '-showProduct');
        if (showProductStr) {
          this.showProductExtentionColumn = JSON.parse(showProductStr);
        }
        const showCustomerStr = localStorage.getItem(this.saveStateKey + '-showCustomer');
        if (showCustomerStr) {
          this.showCustomerColumn = JSON.parse(showCustomerStr);
        }
        const showSellerStr = localStorage.getItem(this.saveStateKey + '-showSeller');
        if (showSellerStr) {
          this.showSellerColumn = JSON.parse(showSellerStr);
        }

      //  const toDateStr = localStorage.getItem(this.saveStateKey + '-toDate');
      //  if (toDateStr) {
      //    this.toDate = new Date(JSON.parse(toDateStr));
      //  }
      //  const docTypesStr = localStorage.getItem(this.saveStateKey + '-docTypes');
      //  if (docTypesStr) {
      //    this.selectedDocTypes = JSON.parse(docTypesStr);
        //  }

      } catch (e) {
        console.error('*** ListProductsCustomersTransactionsComponent ngOnInit: Error in restoring state from localStorage: ' + e);
        this.toDate = new Date();
        this.fromDate = null;
        this.selectedDocTypes = [];

        this.showProductExtentionColumn = false;
        this.showCustomerColumn = false;
        this.showSellerColumn = false;
      }
    }

    this._productQuery = this.listOptions$
      .pipe(
        tap(() => {
          this.contentLoading = true;
          this.productInfo = []; // Reset data
        }),

        tap(options => console.log('*** options:', options)),

        // Add error handling for mainId lookup
        concatMap(options => this.cliApi.getMainIdByClientId(options.clientId).pipe(
          catchError(err => {
            console.error('*** ListProductsCustomersTransactionsComponent Error fetching mainId:', err);
            return of([]); // Return empty array to continue stream
          }),
          map(mainId => {
            if (!mainId || mainId.length === 0) {
              console.warn('*** ListProductsCustomersTransactionsComponent No mainId found for client:', options.clientId);
              return null; // Signal no data
            }
            return { ...options, clientId: mainId[0].CLIID };
          })
        )),

        // Don't use filter - handle null in switchMap instead
        switchMap(options => {
          // If no valid options, return empty and let finalize run
          if (options === null) {
            console.log('*** No valid clientId, returning empty data');
            this.productInfo = [];
            this.totalRecords = 0;
            return of([]);
          }

          const queryOptions = this.buildQueryOptions(options);

          return this.prodApi.findProductsTransactionsByCustomer(queryOptions).pipe(
            timeout(10000),
            retry(1),

            // Only transform data here, don't touch contentLoading
            map(data => {
              this.productInfo = data;
              this.totalRecords = data.length;
              return data;
            }),

            tap(data => environment.production || console.table(data)),

            catchError(err => {
              console.error('ListProductsCustomersTransactionsComponent Error contentLoading products:', err);
              this.messageService.add({
                severity: 'error',
                summary: 'Помилка завантаження',
                detail: this.getUserFriendlyError('loadData', err),
                life: 5000
              });
              // Return empty array to allow finalize to run
              return of([]);
            }),

            // ALWAYS runs - even on error or completion
            finalize(() => {
              console.log('*** ListProductsCustomersTransactionsComponent finalize - records:', this.totalRecords);
              this.contentLoading = false; // ✅ ONLY place to set contentLoading = false
            })
          );
        }),
      )
      .subscribe({
        next: data => {
          console.log('*** ListProductsCustomersTransactionsComponent Loaded records:', data.length);
        },
        error: err => {
          console.error('*** ListProductsCustomersTransactionsComponent Subscription error:', err);
          // finalize already ran, but be defensive
          this.contentLoading = false;
        }
      });

    this.docApi.getDocTypes().subscribe(
      {
        next: types => {
          this.docTypes = types.filter(e => this.allowedDocTypes.includes(e.DOCTYPEID));

          this.selectedDocTypes = this.docTypes.filter(e => this.initialDocTypes.includes(e.DOCTYPEID));

          this.listOptions$.next({
            clientId: this.clientId,
            fromDate: this.fromDate,
            toDate: this.toDate,
            docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : this.initialDocTypes
          });

        },
        error: err => {
          this.contentLoading = false;
          console.error('*** ListProductsCustomersTransactionsComponent ngOnInit getDocTypes error: ' + err);
        }
      }
    );
  }

  clearOrResetTableFilter(event) {
    console.log('*** ListProductsCustomersTransactionsComponent clearOrResetTableFilter: ' + JSON.stringify(event));

    this.table.clear();
    this.table.filterGlobal('', 'contains');

    this.selectedRow = null;

    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

      saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  onExportData() {
    console.log('*** ListProductsCustomersTransactionsComponent onExportData: ')

    import("xlsx").then(xlsx => {

      environment.production || console.table(this.productInfo);

      const exportData: any =
        this.productInfo.map(e => ({

          'Код товара': e.PRODCODE,
          'Наименование товара (рус.)': e.DOCITEMPRODNAME,
          'Цена (грн)': e.DOCITEMPRICE,
          'Цена (валюта)': e.DOCITEMVPRICE,
          'Заказано': e.ORDERED,
          'Отгружено': e.SHIPPED,
          'Группа товара (рус.)': e.PGROUPNAME,
          'Категория товара (укр.)': e.ProductCategory,
          'Номер документа': e.INVOICE,
          'Дата документа': new Date(e.DOCDATE),
          'Клиент (коротко)': e.CUSTOMER_NICKNAME,
          'Клиент (полное название)': e.CUSTOMER,
          'Продавец': e.SELLER,
          'Автор документа': e.AUTHOR


       }));

        const worksheet = xlsx.utils.json_to_sheet(exportData || []);
        const workbook = { Sheets: { invoices: worksheet }, SheetNames: ['invoices'] };

        const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });

        this.saveAsExcelFile(excelBuffer, "invoices");
    });
  }

  onDocTypeChange(event) {
    console.log('*** ListProductsCustomersTransactionsComponent onDocTypeChange: ' + JSON.stringify(event));
    //environment.production || console.log('*** DocumentsComponent onDocTypeChange: ' + JSON.stringify(this.selectedDocTypes));

    environment.production || console.table(this.selectedDocTypes);
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onAllDocTypeChange(event) {
    console.log('*** ListProductsCustomersTransactionsComponent onAllDocTypeChange: ' + JSON.stringify(event));
    //environment.production || console.log('*** DocumentsComponent onAllDocTypeChange: ' + JSON.stringify(this.selectedDocTypes));

    this.selectAllTypes = event.checked;
    this.selectedDocTypes = this.selectAllTypes ? [...this.docTypes] : [];

    environment.production || console.table(this.selectedDocTypes);
    //  this.table.filter(this.selectedDocTypes, 'DOCTYPEID', 'in');
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onDateRangeChangeFrom(event) {
    //console.log('*** ListProductsCustomersTransactionsComponent onDateRangeChange: ' + JSON.stringify(event));
    //console.log('*** ListProductsCustomersTransactionsComponent onDateRangeChange: ' + JSON.stringify(this.filterDate));
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onDateRangeClearFrom(event) {
    //console.log('*** ListProductsCustomersTransactionsComponent onDateRangeClear: ' + event.value);
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onTodayClickFrom(event) {
    //console.log('*** ListProductsCustomersTransactionsComponent onDateRangeClear: ' + event.value);

    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onDateRangeChange(event) {
    //console.log('*** ListProductsCustomersTransactionsComponent onDateRangeChange: ' + JSON.stringify(event));
    //console.log('*** ListProductsCustomersTransactionsComponent onDateRangeChange: ' + JSON.stringify(this.filterDate));
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onDateRangeClear(event) {
    //console.log('*** ListProductsCustomersTransactionsComponent onDateRangeClear: ' + event.value);
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onTodayClick(event) {
    //console.log('*** ListProductsCustomersTransactionsComponent onDateRangeClear: ' + event.value);
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  reloadTable(event) {
    //console.log('*** ListProductsCustomersTransactionsComponent onDateRangeClear: ' + event.value);
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }
}
